export const hasIncompleteProfile = member => !member['first-name'] || !member['last-name'];

export const formatMemberBody = (id, attributes) => ({ data: { id, attributes } });

export default hasIncompleteProfile;
